import React, { Fragment, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Add, MenuBook } from "@mui/icons-material";
import { tractHeader } from "../utils/HeaderData";
import CustomTable from "../templates/CustomTable";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../firebase";
import { useUser } from "../components/context/UserContext";

const SbcTracts = () => {
  const navigate = useNavigate();
  const { userRole, loading } = useUser();
  const canManage = userRole !== "operator";
  const [tracts, setTracts] = useState([]);

  useEffect(() => {
    if (!loading && userRole === "editor") navigate("/home");
  }, [loading, userRole, navigate]);

  React.useEffect(() => {
    const fetchTracts = async () => {
      try {
        const q = query(collection(db, "sbc-tracts"), orderBy("createdAt", "desc"));
        const snap = await getDocs(q);
        setTracts(
          snap.docs.map((d) => {
            const data = d.data();
            const tractDate = data.date ? new Date(`${data.date}T00:00:00`) : null;
            return {
              _id: d.id,
              ...data,
              monthYear: tractDate
                ? tractDate.toLocaleDateString("en-GB", { month: "long", year: "numeric" })
                : "",
              createdAt: data.createdAt?.toDate() || new Date(),
            };
          })
        );
      } catch (err) {
        console.error(err.message);
      }
    };
    fetchTracts();
  }, []);

  return (
    <Fragment>
      <div className="min-h-screen bg-[#f5f7fe] p-3 sm:p-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-0 mb-6">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-[#fffbeb] flex items-center justify-center flex-shrink-0">
                <MenuBook style={{ color: "#d97706", fontSize: 20 }} />
              </div>
              <div>
                <h1 className="text-xl sm:text-2xl font-bold text-[#000C66] font-aref">SBC Tracts</h1>
                <p className="text-gray-400 text-xs font-abel">Manage SBC tract links</p>
              </div>
            </div>
            {canManage && (
              <button
                onClick={() => navigate("/create-tract")}
                className="flex items-center justify-center gap-2 bg-[#000C66] text-white px-5 py-2.5 rounded-xl hover:bg-blue-900 transition font-abel text-sm font-semibold w-full sm:w-auto"
              >
                <Add style={{ fontSize: 18 }} /> Add Tract
              </button>
            )}
          </div>

          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
            <CustomTable
              headers={tractHeader}
              data={tracts}
              editPath={canManage ? "/update-tract" : null}
              deletePath={canManage ? "/delete-tract" : null}
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default SbcTracts;
